import React, { createContext, useState, ReactNode, useEffect } from "react";
import { ActionItem, ChannelState, ChannelSubstate, getChannelHistoryStatusString, SKChannel, Tier } from "../models/SKChannel";
import {
  createChannel,
  deleteChannel,
  deleteChannelEdits,
  getChannel,
  getChannelEdits,
  getUserCreatedChannel,
  updateChannel,
  updateChannelEditStatus,
  updateChannelHistory,
  updateChannelStatus,
} from "../api/channels/channelServices";

export interface ModeratorChannelContextType {
  channelData?: SKChannel;
  updateChannelData: React.Dispatch<React.SetStateAction<SKChannel | undefined>>;
  loading: boolean;
  setChannelId: (channelId: string) => void;
  channelId?: string;
  updateStatus?: (contentId: string, actionItem: ActionItem, reason?: string, note?: string) => void;
  updateDataOnServer?: () => void;
  isEditReview?: boolean;
  originalSubstate?: ChannelSubstate;
}

const channelInitialState: ModeratorChannelContextType = {
  setChannelId: () => {},
  updateChannelData: () => {},
  loading: false,
};

export const ModeratorChannelContext = createContext<ModeratorChannelContextType>(channelInitialState);

interface ModeratorChannelProviderProps {
  children: ReactNode;
  isEditReview?: boolean;
  editChannelId?: string;
}

const ModeratorChannelProvider = ({ children, isEditReview, editChannelId = undefined }: ModeratorChannelProviderProps) => {
  const [channelData, updateChannelData] = useState<SKChannel | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [channelId, setChannelId] = useState<string | undefined>(undefined);
  const [originalSubstate, setOriginalSubstate] = useState<ChannelSubstate | undefined>(undefined);

  const updateDataOnServer = async () => {
    setLoading(true);
    if (channelData && channelData.id) {
      await updateChannel(channelData.id!, channelData);
    }
    setLoading(false);
  };

  const updateStatus = async (contentId: string, actionItem: ActionItem, reason?: string, note?: string) => {
    var data: any = {};
    setLoading(true);
    switch (actionItem) {
      case ActionItem.approve:
        await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.NONE, reason, note);
        data = { status: ChannelState.ACTIVE, subStatus: ChannelSubstate.NONE };
        break;
      case ActionItem.approve_edit:
        //await updateChannelStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.EDIT_APPROVED);

        try {
          const { id, status, subStatus, ...rest } = await getChannelEdits(contentId);
          await updateChannel(contentId, { ...rest, status: ChannelState.ACTIVE, subStatus: ChannelSubstate.EDIT_APPROVED });
          await updateChannelHistory(contentId, getChannelHistoryStatusString(ChannelState.ACTIVE, ChannelSubstate.EDIT_APPROVED, true));
          await deleteChannelEdits(contentId);
          setOriginalSubstate(ChannelSubstate.EDIT_APPROVED);
        } catch (error) {
          console.log(error);
        }

        data = { status: ChannelState.ACTIVE, subStatus: ChannelSubstate.EDIT_APPROVED };
        break;
      case ActionItem.reject_edit:
        await updateChannelEditStatus(contentId, ChannelState.ACTIVE, ChannelSubstate.EDIT_REJECTED, reason, note);
        data = { status: ChannelState.ACTIVE, subStatus: ChannelSubstate.EDIT_REJECTED };
        setOriginalSubstate(ChannelSubstate.EDIT_APPROVED);
        break;
      case ActionItem.reject:
        await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.REJECTED, reason, note);
        data = { status: ChannelState.DRAFT, subStatus: ChannelSubstate.REJECTED };
        (channelData?.subStatus === ChannelSubstate.EDIT_IN_DRAFT ||
          channelData?.subStatus === ChannelSubstate.EDIT_REJECTED ||
          channelData?.subStatus === ChannelSubstate.EDIT_IN_REVIEW) &&
          (await deleteChannelEdits(contentId));
        break;
      case ActionItem.delete:
        deleteChannel(contentId);
        // await updateChannelStatus(contentId, ChannelState.DRAFT, ChannelSubstate.DEACTIVATED, ActionItem.withdraw, reason, note);
        // updateLocalStatus(contentId, State.published);
        break;
      default:
    }
    setLoading(false);
    updateChannelData(prev => ({ ...prev, ...data }));
  };

  useEffect(() => {
    const getChannel2 = async (id: string) => {
      setLoading(true);
      console.log("IsEditReview :", isEditReview);
      if (isEditReview) {
        const { subStatus } = await getChannel(id);
        setOriginalSubstate(subStatus);
      }
      try {
        const channelnew = isEditReview ? await getChannelEdits(id) : await getChannel(id);
        updateChannelData(prev => ({ ...prev, ...channelnew }));
      } catch (error) {
        console.log(error);
      }

      setLoading(false);
    };
    channelId && getChannel2(channelId);
  }, [channelId, isEditReview]);

  // useEffect(() => {
  //   const getChannel2 = async (id: string) => {
  //     setLoading(true);
  //     const channelnew = await getChannel(id);
  //     updateChannelData(prev => ({ ...prev, ...channelnew }));
  //     setLoading(false);
  //   };
  //   channelId && getChannel2(channelId);
  // }, [editChannelId]);

  return (
    <ModeratorChannelContext.Provider
      value={{ setChannelId, channelData, updateStatus, updateDataOnServer, updateChannelData, channelId, loading, isEditReview, originalSubstate }}
    >
      {children}
    </ModeratorChannelContext.Provider>
  );
};

export default ModeratorChannelProvider;
